import type { ReactNode } from 'react';
import { IconButton } from '@/components/ui/icon-button';

interface AppBarProps {
  title?: string;
  onBack?: () => void;
  onClose?: () => void;
  right?: ReactNode;
  brand?: boolean;
  scrolled?: boolean;
}

export function AppBar({ title, onBack, onClose, right, brand, scrolled }: AppBarProps) {
  return (
    <header className={`wb-topbar ${scrolled ? 'is-scrolled' : ''}`}>
      {brand ? (
        <div className="wb-row wb-gap-10 wb-grow">
          <img src="/weebee-bee.png" alt="WayQ" style={{ width: 30, height: 30 }} />
          <div className="wb-topbar-title" style={{ fontFamily: 'var(--font-display)' }}>
            WayQ Tickets
          </div>
        </div>
      ) : (
        <>
          {onBack && <IconButton name="back" label="Back" bare onClick={onBack} />}
          <div className="wb-topbar-title wb-grow" style={{ marginLeft: onBack ? 0 : 6 }}>
            {title}
          </div>
        </>
      )}
      <div className="wb-row wb-gap-6">
        {right}
        {onClose && <IconButton name="close" label="Close" bare onClick={onClose} />}
      </div>
    </header>
  );
}
